import React from "react";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";

interface MinicartDiscountsProps {
  cart_subtotal: number;
  settings: {
    discount_message?: string;
    discount_message_success?: string;
    discount_threshold?: number;
    discount_message_style?: string;
    discount_message_success_style?: string;
  };
}

export const MinicartDiscounts = ({ cart_subtotal, settings }: MinicartDiscountsProps) => {
    if (!settings) return null;

    let message = settings.discount_message || "You need to spend another {difference} to qualify for free shipping";
    const threshold = settings.discount_threshold || 100;
    const thresholdMet = cart_subtotal >= threshold;
    
    // Font styles for different message types
    const defaultTextStyle = settings.discount_message_style || 'text-base';
    const successTextStyle = settings.discount_message_success_style || defaultTextStyle;
    
    // Select the appropriate message and style based on threshold status
    let messageText = '';
    let textStyle = '';
    
    if (thresholdMet) {
        messageText = settings.discount_message_success || "Your order qualifies for free shipping";
        textStyle = successTextStyle;
    } else {
        const currencySymbol = window.Alpine?.store('currency').getCurrencySymbol();
        const diff = threshold - cart_subtotal;
        messageText = message.replace('{difference}', `${currencySymbol}${diff.toFixed(2)}`);
        textStyle = defaultTextStyle;
    }

    // Calculate progress percentage
    const progressPercentage = Math.min(100, (cart_subtotal / threshold) * 100);

    return (
        <div className="shipping-threshold-message mt-4 mb-4">
            <div className={`shipping-message py-3 px-4 rounded-lg ${thresholdMet ? 'bg-green-50 text-green-800' : 'bg-gray-50'}`}>
                <div className="flex items-center">
                    {thresholdMet ? (
                        <span className="icon-check-circle mr-2 text-green-600"></span>
                    ) : (
                        <span className="icon-shipping mr-2"></span>
                    )}
                    <Paragraph classes={textStyle} text={messageText} />
                </div>
                
                {/* Progress bar */}
                {!thresholdMet && (
                    <div className="shipping-progress mt-2">
                        <div className="shipping-progress-bar bg-gray-200 h-2 rounded-full overflow-hidden">
                            <div 
                                className="shipping-progress-fill bg-green-600 h-full" 
                                style={{ width: `${progressPercentage}%` }}
                            ></div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};